import { SortHeader } from './ui'

/**
 * F-095 (REQ-277-001): intestazione di colonna ordinabile per le liste anagrafiche. Il valore di `sort`
 * e' quello che il backend accetta (`<campo>_asc` | `<campo>_desc`, es. `name_asc`): il click passa da
 * crescente a decrescente sullo stesso campo, altrimenti parte da crescente.
 */
export function SortableTh({
  label,
  field,
  sort,
  onSort,
}: {
  label: string
  field: string
  sort: string
  onSort: (next: string) => void
}) {
  const asc = `${field}_asc`
  const desc = `${field}_desc`
  const active = sort === asc || sort === desc
  const next = sort === asc ? desc : asc
  return (
    <SortHeader
      label={label}
      sortKey={field}
      activeKey={active ? field : null}
      direction={sort === desc ? 'desc' : 'asc'}
      onSort={() => onSort(next)}
    />
  )
}
